import {
  IconButton,
  SpeedDial,
  SpeedDialAction,
  SpeedDialContent,
  SpeedDialHandler,
  Typography,
} from "@material-tailwind/react";
import {
  faFlask,
  faLayerGroup,
  faPlus,
  faSitemap,
  faTools,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "../hooks/useModal";

export function ToolsSpeedDial({ token, showPipeline, setShowPipeline }) {
  const { openModal } = useModal();

  return (
    <div className="fixed h-80 w-full">
      <div className="fixed bottom-3 right-7">
        <SpeedDial>
          <SpeedDialHandler>
            <IconButton
              size="lg"
              className="rounded-full opacity-80 shadow-[rgba(255,255,255,0.5)_0px_0px_4px_5px] hover:shadow-[rgba(255,255,255,0.5)_0px_0px_4px_5px]"
            >
              <FontAwesomeIcon
                icon={faTools}
                size="xl"
                className="transition-transform group-hover:rotate-180"
              />
            </IconButton>
          </SpeedDialHandler>

          <SpeedDialContent>
            {/* Manage Topics */}
            <SpeedDialAction className="h-20 w-20 bg-indigo-400 opacity-90">
              <div
                onClick={() => {
                  openModal("manage-topics", { token });
                }}
              >
                <FontAwesomeIcon
                  icon={faLayerGroup}
                  className="h-6 w-6 text-white -mt-3"
                />

                <Typography color="white" className="text-xs font-bold">
                  Manage Topics
                </Typography>
              </div>
            </SpeedDialAction>

            {/* New card */}
            <SpeedDialAction className="h-20 w-20 bg-indigo-400 opacity-90">
              <div
                onClick={() => {
                  openModal("card-create", { token });
                }}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  className="h-6 w-6 text-white -mt-3"
                />

                <Typography color="white" className="text-xs font-bold">
                  Add New Card
                </Typography>
              </div>
            </SpeedDialAction>

            {/* Analysis */}
            <SpeedDialAction className="h-20 w-20 bg-indigo-400 opacity-90">
              <div
                onClick={() => {
                  openModal("analysis", { token });
                }}
              >
                <FontAwesomeIcon
                  icon={faFlask}
                  className="h-6 w-6 text-white -mt-3"
                />

                <Typography color="white" className="text-xs font-bold">
                  Analysis
                </Typography>
              </div>
            </SpeedDialAction>

            {/* Pipelines */}
            <SpeedDialAction className="h-20 w-20 bg-indigo-400 opacity-90">
              <div onClick={() => setShowPipeline(true)}>
                <FontAwesomeIcon
                  icon={faSitemap}
                  className="h-6 w-6 text-white -mt-3"
                />
                <Typography color="white" className="text-xs font-bold">
                  Pipelines
                </Typography>
              </div>
            </SpeedDialAction>
          </SpeedDialContent>
        </SpeedDial>
      </div>
    </div>
  );
}
